import axios from "axios";
import mdx from "modax";
import Vue from "vue";
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
});
request.interceptors.request.use((config) => {
  // const instance = mdx()
  //   .loading()
  //   .title("联网缓冲中")
  //   .show();
  Object.defineProperty(config, "_mdx_loading", {
    configurable: true,
    get() {
      // return instance;
      return true
    },
  });
  return config;
});
request.interceptors.response.use((response) => {
  mdx.close(response.config._mdx_loading._id);
  return response.data.result;
});
Vue.prototype.$http = request;

export default request;
